module.exports = __webpack_public_path__ + "static/media/food-interest.30114345.svg";